import styled from 'styled-components';
import tw from 'tailwind-styled-components';
import { Text, Title } from '../Typography';
import { ReactNode, Ref } from 'react';

// Common interface for children prop
interface WithChildren {
  children?: ReactNode;
  className?: string;
}

export const ArrowWrapper = styled.div<WithChildren>`
  display: inline;
  vertical-align: middle;
  svg {
    display: inline;
    vertical-align: top;
  }
`;
ArrowWrapper.displayName = 'Wrapper';

export const Wrapper = styled.div<{ $height?: any; children?: ReactNode }>`
  height: ${(props) => props.$height || '100%'};
  cursor: pointer;
  > div {
    height: 100%;
  }
`;
Wrapper.displayName = 'Wrapper';

export const ProductImage = styled.div<WithChildren & { ref?: Ref<HTMLImageElement> }>`
  z-index: 9;
  position: relative;
  width: 190px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform-origin: center;
  transition: transform 0.4s;
  margin-left: 50%;
  transform: translateX(-50%);
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  @media (min-width: 768px) {
    height: 250px;
  }
`;

export const ProductSubTitle = styled(Text)`
  height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  margin-bottom: 8px;
  margin-top: 22px;
`;

export const ProductTitle = styled(Title)`
  height: 100%;
  height: 93px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  line-clamp: 3;
`;

export const SubCategoryImage = styled.div<WithChildren>`
  z-index: 9;
  position: relative;
  width: 230px;
  height: 230px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform-origin: center;
  transition: transform 0.4s;
  margin-left: 50%;
  transform: translateX(-50%);
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const LinkWrapper = styled.div<{
  $variation?: string;
  $dominantColor?: string;
  children?: ReactNode;
}>`
    a {
        color: #292b29;
    }
    .card-link-component {
      .card-subcategory {
          width: 220px;
          max-width: 100%;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          @media (max-width: 480px) {
            margin-bottom: 10px;
          }
      }
        // &:focus {
        //     .card-container {
        //       @media (min-width: 640px) {
        //         border: 3px solid #5A5E5A;
        //         border-radius: 1.2rem;
        //       }
        //     }
        //     outline: none;
        // }
        &:hover {
            .hidden-until-hover-or-focus-on-desktop {
                max-height: 100px;
                opacity: 1;
                transition: max-height 0.8s, opacity 0.8s;
            }

            .card-image {
                width: 70%;
                left: 13%;
            }
            ${ProductImage} {
              @media (min-width: 640px) {
                transform: translateX(-50%) scale(0.75);
              }
            }
            .card-subcategory {
              margin-bottom: 5px;
              @media (min-width: 640px) {
                width: 270px;
              }
              @media (max-width: 480px) {
                margin-bottom: 10px;
              }
            }

            .card-product {
              @media (min-width: 640px) {
                width: 70%;
                left: 12%;
              }
            }

            .curve-svg-product, .svg-product {
                path {
                    fill: ${(p) => p.$dominantColor};
                    stroke: none;
                }
            }
            .card-content-wrapper {
                ${(p) =>
                  p.$variation === 'product' &&
                  `
                    background-color: ${p.$dominantColor};
                    border: 0;
                  `}
            }

        }
    }
}
`;
LinkWrapper.displayName = 'LinkWrapper';

export const MainContainer = tw.div`
    h-full
`;
MainContainer.displayName = 'MainContainer';

export const Container = styled.div<{
  $contentPadding?: number;
  $variation?: string;
  children?: ReactNode;
  className?: string;
  'data-test'?: string;
  ref?: Ref<HTMLDivElement>;
  onClick?: () => void;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-items: stretch;
  height: 100%;
  overflow: hidden;
  border-radius: 1rem;
  ${(p) => p.$contentPadding && `padding-bottom: ${p.$contentPadding}px;`}
  ${(p) =>
    p.$variation === 'article' &&
    `
        align-items: center;
        flex-direction: row;
        padding-bottom: 0;
        border: 1px solid #BBC4BA;
        background-color: #fff;
    `}
`;
Container.displayName = 'Container';

export const Content = styled.div<{
  $backgroundHsl: string;
  $variation?: string;
  $type?: string;
  $isPlaceholder?: boolean;
  children?: ReactNode;
  className?: string;
  'data-test'?: string;
  ref?: Ref<HTMLDivElement>;
}>`
  width: 100%;
  padding: 0px 19px 30px;
  background-color: ${(p) => p.$backgroundHsl};
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;

  ${(p) =>
    p.$isPlaceholder &&
    (p.$variation === 'recipe' ||
      p.$variation === 'articleImage' ||
      p.$variation === 'tipsAndTricks')
      ? `visibility: hidden;`
      : `
        position: absolute;
        bottom: 0;`}

  h3 {
    font-weight: bold;
  }
  .authorable-card-big {
    margin-bottom: -30px;
  }
  ${(p) =>
    p.$variation === 'product' || p.$variation === 'white'
      ? `
        background-color: #ffffff;
        border: 1px solid #BBC4BA;
        border-top: 0;
    `
      : ''}
  ${(p) =>
    p.$variation === 'object'
      ? `padding-top: 60px;`
      : p.$variation === 'product' || p.$variation === 'white'
      ? `padding-top: 55px;`
      : 'padding-top: 0px;'}

  ${(p) =>
    p.$variation === 'subcategory'
      ? `
      padding-bottom: 50px;
      padding-top: 30px;
    `
      : ''}
      ${(p: any) =>
    p.$variation === 'article'
      ? `
            background-color: #ffffff;
            border: 0;
            position: static;
        `
      : ''}
  ${(p) =>
    p.$type === 'big'
      ? `
       padding-bottom: 0;
       .card-content-big {
         margin-bottom: -20px;
       }
    `
      : ''}
`;

export const HiddenImageForColorDetection = styled.img<{
  ref?: Ref<HTMLElement>;
  crossOrigin?: string;
  alt?: string;
  className?: string;
  width?: string;
  height?: string;
  onLoad?: () => void;
}>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  ref?: RefObject<HTMLImageElement> | null;
`;

export const Image = styled.div<
  WithChildren & {
    ref?: Ref<HTMLImageElement>;
    'data-src'?: string;
    crossOrigin?: string;
    alt?: string;
    onLoad?: () => void;
    width?: string;
    height?: string;
  }
>`
  flex-grow: 2;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  overflow: hidden;
  width: 100%;
`;

// showAll prop turns off the css which works with the card animation to hide some of the card info on load.
// Some cards require all card info to be displayed upon load
export const HiddenUntilHoverOrFocus = styled.div<{
  $showAll: boolean;
  children?: ReactNode;
  className?: string;
}>`
  ${(p) =>
    p.$showAll
      ? ``
      : `@media (min-width: 640px) {
        max-height: 0;
        opacity: 0;
        padding-bottom: 0;
        transition: max-height 0.2s, opacity 0.2s;
      }`}
`;
HiddenUntilHoverOrFocus.displayName = 'HiddenUntilHoverOrFocus';

// This SVG is the "negative border-radius" shape at the top
// of the content box.

export const Svg = styled.svg<{
  $variation?: string;
  $type?: string;
  children?: ReactNode;
  xmlns?: string;
  viewBox?: string;
  width?: string;
  height?: string;
  fill?: string;
  className?: string;
}>`
  position: absolute;
  left: -50px;
  width: calc(100% + 100px);
  bottom: 100%;
  ${(p) =>
    p.$variation === 'product' &&
    (p.$type === 'mediumSmall'
      ? `bottom: calc(100% + 69px);
    @media (min-width: 1024px) and (max-width:1439px ) {
      bottom: calc(100% + 70px)
    }
    `
      : `bottom: calc(100% + 68px);`)}
  ${(p) =>
    p.$variation === 'object' &&
    (p.$type === 'mediumSmall' ? `bottom: calc(100% + 73px);` : `bottom: calc(100% + 73px);`)}

  ${(p) =>
    p.$variation === 'recipe' &&
    (p.$type === 'mediumSmall' ? `bottom: calc(100% + 12px);` : `bottom: calc(100% + 12px);`)}

  ${(p) =>
    p.$variation === 'white' &&
    (p.$type === 'mediumSmall' ? `bottom: calc(100% + 12px);` : `bottom: calc(100% + 12px);`)}

  ${(p) =>
    p.$variation === 'WideSmall' &&
    (p.$type === 'mediumSmall' ? `bottom: calc(100% + 12px);` : `bottom: calc(100% + 12px);`)}

  ${(p) =>
    p.$variation === 'content' &&
    (p.$type === 'mediumSmall' ? `bottom: calc(100% + 12px);` : `bottom: calc(100% + 12px);`)}

  ${(p) =>
    p.$variation === 'article' && (p.$type === 'mediumSmall' ? `display:none;` : `display:none;`)}

  ${(p) =>
    p.$variation === 'articleImage' &&
    (p.$type === 'mediumSmall' ? `bottom: calc(100% + 12px);` : `bottom: calc(100% + 12px);`)}

  ${(p) =>
    p.$variation === 'subcategory' &&
    (p.$type === 'mediumSmall' ? `bottom: calc(100% + 36px);` : `bottom: calc(100% + 12px);`)}

  ${(p) =>
    p.$variation === 'tipsAndTricks' &&
    (p.$type === 'mediumSmall' ? `bottom: calc(100% + 12px);` : `bottom: calc(100% + 12px);`)}
`;
export const Video = styled.div<{
  $backgroundHsl: string;
  children?: ReactNode;
  className?: string;
}>`
  position: absolute;
  left: calc(50% - 22px);
  background-color: ${(p) => p.$backgroundHsl};
  width: 50px;
  height: 50px;
  z-index: 1;
  border-radius: 50%;
`;

export const VideoCircle = styled.span<WithChildren>`
  border: 1px solid #000;
  padding: 5px 5px 0;
  display: inline-block;
  margin: 5px;
  border-radius: 50%;
`;

export const Dots = styled.span<WithChildren>`
  display: inline-block;
  width: 4px;
  height: 4px;
  background-color: #000;
  border-radius: 4px;
  margin: 3px 10px;
`;

export const ObjectImage = styled.div<{
  $cardVariation: string;
  children?: ReactNode;
  className?: string;
}>`
  position: ${(p) => `${p.$cardVariation == 'object' ? 'absolute' : 'unset'}`};
  z-index: 9;
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: width 0.4s, left 0.4s;
  left: 5%;
  bottom: 196px;
  &.card-image {
    bottom: 186px;
`;

export const Curve = styled.div<{
  $variation?: string;
  children?: ReactNode;
}>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  ${(p) =>
    p.$variation === 'white' &&
    `
        display: none;
    `}
`;

export const CurveSVG = styled.svg<{
  $contentTop: number;
  $variation?: string;
  $shouldBeVisible: boolean;
  $topOfHoveredContent: number;
  $type?: string;
  children?: ReactNode;
}>`
  position: absolute;
  opacity: 0;
  width: 200%;
  left: -50%;
  top: ${(p) => p.$contentTop}px;
  transform: translateY(${(p) => p.$contentTop}px);
  transition: transform 0.4s;

  ${(p) =>
    p.$variation === 'white' &&
    `
        display: none;
    `}

  ${(p) => p.$shouldBeVisible && 'opacity: 1;'}

    &:hover {
    ${(p) => `transform: translateY(${p.$topOfHoveredContent}px);`}
    ${(p) => p.$variation === 'WideSmall' && `top: ${p.$topOfHoveredContent + 20}px;`}
  }
`;

export const Info = tw.div`
    uppercase
    text-center
    text-opacity-75
    tracking-widest
    mb-5
`;
Info.displayName = 'Info';

export const ButtonContainer = tw.div<{
  $showAll: boolean;
  children?: ReactNode;
}>`
  flex
  justify-center
  relative
  -mt-6
  ${(p) =>
    p.$showAll
      ? `
      -mb-12
      `
      : `-mb-10
      md:my-auto`}
`;
ButtonContainer.displayName = 'ButtonContainer';

export const ProductsAmount = tw(Text)`
  uppercase
  text-center
  opacity-70
  text-darkgrey
  tracking-widest
  mb-2.5
  md:mb-18
  md:leading-4.5
`;
ProductsAmount.displayName = 'ProductsAmount';
